module.exports = {"340172001":"莲花社区管理委员会街道","340172002":"芙蓉社区管理委员会街道","340172003":"锦绣社区管理委员会街道","340172004":"海恒社区管理委员会街道","340172005":"临湖社区管理委员会街道","340172006":"高刘街道街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340172.json
// module id = 1147
// module chunks = 0